import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import BottomNav from '../components/BottomNav/BottomNav';
import InstallPrompt from '../components/Pwa/InstallPrompt';
import TickerBanner from '../components/Ticker/TickerBanner';
import { useLayout } from '../context/LayoutContext';
import { useScreenType } from '../hooks/useScreenType';
import { useOnboardingStatus } from '../hooks/useOnboardingStatus';
import OnboardingFavoritesModal from '../components/Onboarding/OnboardingFavoritesModal';
import { useAuth } from '../context/AuthContext';

interface IProps {
  children: React.ReactNode;
  hideNavbar?: boolean;
}

const SiteLayoutContent: React.FC<IProps> = ({ children, hideNavbar = false }) => {
  const { isMobileMenuOpen, closeMobileMenu, isSidebarCollapsed } = useLayout();
  const { isDesktop, isMobile } = useScreenType();
  const { isAuthenticated } = useAuth();
  const { needsOnboarding, refresh } = useOnboardingStatus();

  const showBottomNav = !hideNavbar && isMobile && isAuthenticated;

  return (
    <div className='site-wrapper' style={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {isDesktop && <TickerBanner />}
      <div className='flex' style={{ flex: 1, overflow: 'hidden', display: 'flex' }}>
        {!hideNavbar && (
          <div
            className={`navbar full-height ${isMobileMenuOpen ? 'mobile-visible' : 'responsive-hide'} ${isSidebarCollapsed ? 'collapsed' : ''}`}
            style={{ height: '100%' }}
          >
            <Navbar />
          </div>
        )}

        {/* Overlay for mobile to close menu when clicking outside */}
        {isMobileMenuOpen && (
          <div
            className='mobile-menu-overlay'
            onClick={closeMobileMenu}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 998, // Below navbar (999)
              background: 'rgba(0,0,0,0.5)',
            }}
          />
        )}

        <div
          className={`content full-height flex-1 ${showBottomNav ? 'with-bottom-nav' : ''}`}
          style={{ height: '100%', overflowY: 'auto' }}
        >
          {children}
        </div>
      </div>

      {showBottomNav && <BottomNav />}
      {isAuthenticated && <InstallPrompt />}

      {isAuthenticated && needsOnboarding && (
        <OnboardingFavoritesModal onComplete={() => refresh()} />
      )}
    </div>
  );
};

const SiteLayout: React.FC<IProps> = (props) => (
  <SiteLayoutContent {...props} />
);

export default SiteLayout;
